import http from '@/requests/http'

class RingGroup {
  static all (params) {
    return http.post('configuration/inbound/ring/index', params)
  }
  static async store (params) {
    return http.post('configuration/inbound/ring/store', params)
  }
  static async view (params) {
    return http.post('configuration/inbound/ring/view', params)
  }
  static async update (params) {
    return http.post('configuration/inbound/ring/update', params)
  }
  static async destroy (params) {
    return http.post('configuration/inbound/ring/destroy', params)
  }
}

export default RingGroup
